<template>
  <div class="mini-grid">
    <div>
      <el-button type="primary" @click="printpage()">打印</el-button>
      <el-button type="danger" @click="close()">关闭</el-button>
    </div>
  </div>
</template>

<script>

export default {
  components: { 
  },
  name: "print_shcjftzd_all",
  data() {
    return {
      DJBH:new URLSearchParams(window.location.search).get('DJBH'),
      NY:new URLSearchParams(window.location.search).get('NY'),
      user:JSON.parse(sessionStorage.currentUser)
    };
  },
  methods: {
    close(){
        window.close();
    },
    printpage(){//打印
      let printStr = "<html><head><meta http-equiv='Content-Type' content='text/html;charset=utf-8'></head><body >";
      let content = "";
      let sprnstr = "<!--startprint1-->";//设置打印开始区域
      let eprnstr = "<!--endprint1-->";//设置打印结束区域
      content = content+sprnstr ;//加载打印头

      //纵向：@page { size: portrait; }
      //横向：@page { size: landscape; }
      let sss= "<style"+" type="+"text/css"+">"+"@page { size: auto;margin-top: 5mm;margin-left: 10mm;}"+"body{ zoom:70%;padding: 0px 32px; }"+"</style>" ;
      content+=sss;
      if($("#ipt_count").val()==0){
          $("#ipt_count").val(1);
      }
      let num=$("#ipt_count").val();//打印的页数
      //判断是否只有1页要打印
      if(num==1){
          //只打印一页，是否打印子表
          if( $("#div_box").val()==0 ){
              content+=document.getElementById('model0').innerHTML;
              //let str = document.getElementById('div_model0').innerHTML;     //获取需要打印的页面元素 ，page1元素设置样式page-break-after:always，意思是从下一行开始分割。
              //content+=str;
              content+=document.getElementById('model2').innerHTML;
          }else{
              content+=document.getElementById('model0').innerHTML;
              let str = document.getElementById('div_model0').innerHTML;     //获取需要打印的页面元素 ，page1元素设置样式page-break-after:always，意思是从下一行开始分割。
              content+=str;
              content+=document.getElementById('model2').innerHTML;
          }

      }else{//不止要打印一份
          for (let i=0;i<num;i++){
              content+=document.getElementById('model0').innerHTML;
              let str = document.getElementById('div_model'+i).innerHTML;     //获取需要打印的页面元素 ，page1元素设置样式page-break-after:always，意思是从下一行开始分割。
              content+=str;
              if( (i+1)%2==0 ){
                  content+=document.getElementById('model3').innerHTML;
              }else{
                  content+=document.getElementById('model2').innerHTML;
                  content+="<div"+" style='width:100%;height:150px;'"+"></div>";//加空格
              }

          }
      }

      content = content + eprnstr;//加载打印尾
      printStr = printStr+content+"</body></html>";
      let pwin=window.open("Print.htm","print"); //如果是本地测试，需要先新建Print.htm，如果是在域中使用，则不需要
      pwin.document.write(content);
      pwin.document.close();                   //这句很重要，没有就无法实现
      pwin.print();
      window.location.reload();
    },
    showDJ(data){//展示单据
        //定义一个数组来存储子表数据
        var sss = "";
        console.log(data);
        sss="<br/<br/><h2 style='font-size:24px;font-weight: 600;text-align: center;'>商户催交通知单</h2><br/<br/>"+
        "<table"+"   id=tab_1"+" width=100%"+"  style='border-collapse:collapse;font-size: 9pt;'"+">"+
                        "<thead>"+
                            "<tr>"+
                                "<th>合同编码</th>"+
                                "<th>商户名称</th>"+
                                "<th>经营品牌</th>"+
                                "<th>截止日期</th>"+
                                "<th>经营欠款</th>"+
                                "<th>经营欠款产生违约金</th>"+
                                "<th>前期交款逾期产生违约金</th>"+
                                "<th>欠款+违约金合计</th>"+
                                "<th>备注</th>"+
                                "<th>对账电话</th>"+
                                "<th>楼层</th>"+
                            "</tr>"+
                        "</thead>"+
                    "<tbody>"+
                        "<tr>"+
                            "<td align='center'>"+data.F_HTH+"</td>"+
                            "<td align='center'>"+data.F_GYSMC+"</td>"+
                            "<td align='center'>"+data.F_PPMC+"</td>"+
                            "<td align='center'>"+data.F_JZRQ+"</td>"+
                            "<td align='center'>"+data.F_JYQK+"</td>"+
                            "<td align='center'>"+data.F_JYQK_WYJ+"</td>"+
                            "<td align='center'>"+data.F_JKYQ_WYJ+"</td>"+
                            "<td align='center'>"+data.F_QKWYJHJ+"</td>"+
                            "<td align='center'>"+data.F_BZ+"</td>"+
                            "<td align='center'>"+data.F_SJHM+"</td>"+
                            "<td align='center'>"+data.F_LC+"</td>"+
                        "</tr>"+
                "</tbody>"+
                "<tfoot>"+
                "</tfoot>"+
                "</table><h4>备注:上述经营欠款及违约金请务必及时缴纳！转款时请备注品牌";
                if(data.F_FDBH=="201"){
                    sss+="<img src='/fvue/img/seal.png' width='150px' height='40px' style='padding-left: 36px;'>";
                }
                if(data.F_FDBH=="202"){
                    sss+="<img src='/fvue/img/seal_zs.png' width='150px' height='40px' style='padding-left: 36px;'>";
                }
                sss+="</h4>"+
                "<h4 style='font-size:15px;page-break-after:always;'>上传时间："+data.F_CONFIRM_DATE+"</h4>";;
            $("#model0").append(sss);
            $("#tab_1  th").css("height","25px");
            $("#tab_1 th").css("border","1px solid");
            $("#tab_1  td").css("height","25px");
            $("#tab_1 td").css("border","1px solid");
            $("td").css("font-size","16px");
    },
    changeMoneyToChinese(money){
      let cnNums = new Array("零","壹","贰","叁","肆","伍","陆","柒","捌","玖"); //汉字的数字
      let cnIntRadice = new Array("","拾","佰","仟"); //基本单位
      let cnIntUnits = new Array("","万","亿","兆"); //对应整数部分扩展单位
      let cnDecUnits = new Array("角","分","毫","厘"); //对应小数部分单位
      let cnInteger = "整"; //整数金额时后面跟的字符
      let cnIntLast = "元"; //整型完以后的单位
      let maxNum = 999999999999999.9999; //最大处理的数字

      let IntegerNum; //金额整数部分
      let DecimalNum; //金额小数部分
      let ChineseStr=""; //输出的中文金额字符串
      let parts; //分离金额后用的数组，预定义
      if( money === "" ){
          return "";
      }
      money = parseFloat(money);
      if( money >= maxNum ){
          $.alert('超出最大处理数字');
          return "";
      }
      if( money==0 ){
          ChineseStr = cnNums[0]+cnIntLast+cnInteger;
          return ChineseStr;
      }
      money = money.toString(); //转换为字符串
      if( money.indexOf(".") == -1 ){
          IntegerNum = money;
          DecimalNum = '';
      }else{
          parts = money.split(".");
          IntegerNum = parts[0];
          DecimalNum = parts[1].substr(0,4);
      }
      if( parseInt(IntegerNum,10) > 0 ){//获取整型部分转换
          let zeroCount = 0;
          let IntLen = IntegerNum.length;
          for(let i=0;i<IntLen;i++ ){
              let n = IntegerNum.substr(i,1);
              let p = IntLen - i - 1;
              let q = p / 4;
              let m = p % 4;
              if( n == "0" ){
                  zeroCount++;
              }else{
                  if( zeroCount > 0 ){
                      ChineseStr += cnNums[0];
                  }
                  zeroCount = 0; //归零
                  ChineseStr += cnNums[parseInt(n)]+cnIntRadice[m];
              }
              if( m==0 && zeroCount<4 ){
                  ChineseStr += cnIntUnits[q];
              }
          }
          ChineseStr += cnIntLast;
          //整型部分处理完毕
      }
      if( DecimalNum!= '' ){//小数部分
          let decLen = DecimalNum.length;
          for(let i=0; i<decLen; i++ ){
              let n = DecimalNum.substr(i,1);
              if( n != '0' ){
                  ChineseStr += cnNums[Number(n)]+cnDecUnits[i];
              }
          }
      }
      if( ChineseStr == '' ){
          //ChineseStr += cnNums[0]+cnIntLast+cnInteger;
          ChineseStr += cnNums[0]+cnIntLast;
      }
      if( money.substring(money.length-2,money.length-1)===0   ){
          ChineseStr+='整';
      }
      return ChineseStr;
    }
  },
  mounted(){
    let sql=sessionStorage.getItem("cjsql");
    this.$http.get(context.bpmRunTime+"/bpm/haiyaScript/executeSql?param="+Base64.encode(sql)).then(resp=>{
        if(resp.data.result.length>0){
            for(let i=0;i<resp.data.result.length;i++){
                let ipt="<input type="+"hidden"+" id="+"ipt"+" value="+"0"+">";    //这个input输入框也要隐藏，他的  value 代表是第几页（0代表第一页，默认为0）
                let ipt_count="<input"+" id=ipt_count"+" value="+"0"+" type="+"hidden"+">";//需要隐藏的input ,这个 input 的value是 代表费用子表的记录页数
                let div_hidden="<div"+" id=model_hidden"+"></div>";//需要隐藏的div
                let div_box="<div"+" id="+"div_box"+" value="+"0"+"></div>"; //子表记录条数
                $(".mini-grid").append(ipt);
                $(".mini-grid").append(ipt_count);
                $(".mini-grid").append(div_hidden);
                $(".mini-grid").append(div_box);
                //获取页面跳转时传递的参数
                //开票确认单也要分页
                //默认显示第一页
                let div1="<div"+" class="+"preview"+"  id=model0"+" name="+"model"+"></div>";  //存放页面头
                let div2="<div"+" class="+"preview"+"  id=model1"+" name="+"model"+"></div>";  //存放子表
                let div3="<div"+" class="+"preview"+"  id=model2"+" name="+"model"+"></div>";  //存放页面尾
                let div4="<div"+" class="+"preview"+"  id=model3"+" name="+"model"+" style='display: none;'"+"></div>";  //存放  带有分页标识的表格 (默认隐藏)
                $(".mini-grid").append(div1);
                $(".mini-grid").append(div2);
                $(".mini-grid").append(div3);
                $(".mini-grid").append(div4);
                this.showDJ(resp.data.result[i]);
            }
        }
    })
    let sql_1 = "update w_wy_shcjtz set f_cyr='"+this.user.account+"',f_cysj=to_date(to_char(sysdate,'YYYY-MM-DD HH24:MI:SS'),'YYYY-MM-DD HH24:MI:SS')"+  
    "where id_ in("+sql.replaceAll("select *","select id_").replaceAll("order by F_JZRQ desc","")+") and f_cysj is null";

    this.$http.get(context.bpmRunTime+"/bpm/haiyaScript/executeSql?param="+Base64.encode(sql_1)).then(resp=>{

    })
  }
};
</script>

<style lang="scss" scoped>
</style>